<template>

  <Toast :group="page.name" position="bottom-center" />
  <Loader v-if="loader" />


  <div class="page">
    <div class="formgrid grid ">
      <div class="field col-12 md:col-5">
          <label>Anno</label>
          <Calendar v-model="selectedYear" :showIcon="true" view="year" dateFormat="yy" :manualInput="false" class="inputfield w-full" />
      </div>
      <div class="field col-12 md:col-2 flex align-items-end justify-content-center">
          <Button label="Cerca" icon="pi pi-search" iconPos="right" class="w-full" @click="getData" />
      </div>
    </div>

    <div>
      <DataTable :value="tableData" responsiveLayout="scroll" :filters="filters">
        <template #header>
            <div class="flex justify-content-between flex-wrap">
                <div class="flex align-items-center justify-content-center mb-2">
                  <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                  </span>
                </div>
                <i></i>
                <div>
                  <Badge severity="warning" class="mr-2"></Badge> POD <br>
                  <Badge class="mr-2"></Badge> PDR
                </div>
            </div>
          </template>
        <Column field="name" header="Agente">
          <template #body="{data, field}">
            <span>{{data[field].toUpperCase()}}</span>
          </template>
        </Column>
        <Column v-for="month in months" :key="month" :field="`month_${month}`" :header="getMonthName(month)"  style="min-width:110px">
          <template #body="{data}">
              <Badge severity="warning" class="mr-2">
                {{data[`month_${month}`].pod}}
              </Badge>
              <Badge class="mr-2">
                {{data[`month_${month}`].pdr}}
              </Badge>
              <span v-if="month != 1">
                <i v-if="(data[`month_${month}`].pod+data[`month_${month}`].pdr) < (data[`month_${month-1}`].pod+data[`month_${month-1}`].pdr)" class="pi pi-arrow-down" style="font-size: 0.7rem; color:#c9c9c9"></i>
                <i v-if="(data[`month_${month}`].pod+data[`month_${month}`].pdr) > (data[`month_${month-1}`].pod+data[`month_${month-1}`].pdr)" class="pi pi-arrow-up" style="font-size: 0.7rem; color:#c9c9c9"></i>
                <i v-if="(data[`month_${month}`].pod+data[`month_${month}`].pdr) == (data[`month_${month-1}`].pod+data[`month_${month-1}`].pdr)" style="font-size: 0.6rem; color:#c9c9c9"> &#8212;</i>
              </span>
              <span v-else>
                <i style="font-size: 0.6rem; color:#c9c9c9"> &#8212;</i>
              </span>
          </template>
        </Column>
      </DataTable>
    </div>
    

  </div>
  <div class="wrap-footer-main-dialog">
    <div class="footer-main-dialog">
      <Button 
          label="Chiudi" 
          icon="pi pi-times"
          iconPos="right" 
          class="p-button-secondary mr-3"
          @click="onCancelButton($event)" 
        />
        <!-- <Button 
          label="Esegui" 
          icon="pi pi-check"
          iconPos="right" 
          class="mr-3"
          @click="onOkButton($event)" 
        /> -->
    </div>
  </div>

</template>

<script>
import moment from 'moment'
import { ref, getCurrentInstance, onMounted} from 'vue';
import { FilterMatchMode } from 'primevue/api';
// import Service from '@/services/ask-operation/operation-service'
import AgentiService from '@/services/ask-management/agenti-service'
import Loader from '@/components/Loader.vue'
// import { useToast } from "primevue/usetoast";

export default {
  components: {
    Loader
  },
    
  setup() {
    const page = { name: 'agenti-report-pdp'}
    const loader = ref(false)
    // const toast = useToast();
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const filters = ref({
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
    });
    const tableData = ref();
    const selectedYear = ref(new Date());
    const formatDate = self.appContext.config.globalProperties.$formatDate
    const agentiService = new AgentiService(self.$http, self.$eventBus)
    const months = Array.from({ length: 12 }, (_, i) => i + 1);
    const monthsName = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre']
      
    onMounted(() =>{
     getData()
    })

    const getData = () => {
      loader.value = true
      agentiService.getAgentsReportPdp(moment(selectedYear.value).format('YYYY'))
      .then((res) => {
        tableData.value = transformData(res.items)
      })
      .finally(()=>{
        loader.value = false
      }) 
    }

    const transformData = (data) => {
      return Object.keys(data).map(key => {
        const entry = { name: key };
        months.forEach(month => {
          const podData = data[key].pod.find(item => item.mese === month) || { conteggio: 0 };
          const pdrData = data[key].pdr.find(item => item.mese === month) || { conteggio: 0 };
          // entry[`month_${month}`] = `pod: ${podData.conteggio}/pdr: ${pdrData.conteggio}`;
          entry[`month_${month}`] = {pod:podData.conteggio,pdr:pdrData.conteggio}
        });
        return entry;
      });
    };

    const monthTemplate = (month) => {
      return (rowData) => {
        return rowData[`month_${month}`];
      };
    };

    const getMonthName = (month) => {
      return monthsName[month-1]
    };
    
    const onCancelButton = () => {
       self.$eventBus.emit(`dialog-return-cancel-button`, {})
    }


    return {
      page,
      loader,
      filters,
      formatDate,
      tableData,
      selectedYear,
      getData,
      months,
      monthTemplate,
      getMonthName,
      onCancelButton,
      // onOkButton
    }
  }
}


</script>

<style scoped>
.form-file .button-wrapper {
  position: relative;
  width: 100%;
  text-align: center;
}

.form-file .allowed-format {
  font-size: 12px;
  color: rgb(186, 186, 186);
  margin-top: 2px;
}

.form-file .button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #ffffff;
  border: 1px solid rgb(217, 217, 217) !important; 
  cursor: pointer;
  color: rgb(168, 168, 168);
  padding: 10px 2px;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
}

.form-file .button-wrapper span.label.active {
  background: #2196F3;
  color: white;
}

.form-file #upload {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}
</style>

